import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext';

const PrivateRoute = ({ children }) => {
    const { user, isAgeVerified, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // Logged in but hasn't completed age verification yet
    if (!isAgeVerified && location.pathname !== '/age-verification') {
        return <Navigate to="/age-verification" replace />;
    }

    return children;
};

export default PrivateRoute;
